module.exports = __webpack_public_path__ + "img/temp_banner_promotion01.c66524cc.png";